import React from 'react';
import { Link } from 'react-router-dom';


const CallToAction = () => {
  return (
    <section className="bg-bgDefault text-white lg:px-6 lg:py-10 px-4 py-10">
        <div className="container xl:mx-auto xl:max-w-screen-xl  overflow-hidden">
      <div className=" flex flex-col md:flex-row lg:justify-between lg:items-center">
        
        {/* Left Side - Heading */}
        <div className=" md:text-left text-left mb-6 md:mb-0">
          <h2 className="font-dmsans font-bold text-[34px] leading-[44px] tracking-[-6%] lg:text-heading-2">
            <span className="text-white">Let’s</span>{' '}
            <span className="text-white">Transform Your</span><br />
            <span className="text-white">Vision Into Value.</span>
          </h2>
        </div>

        {/* Right Side - Description & Button */}
        <div className="text-regular space-y-4 max-w-md  lg:text-left">
              <p>
                Revolutionize Your Online Presence with <br />
                Seamless Digital Solutions: Unleashing Web <br />
                Development Excellence
              </p>
              <Link to="/contact" className="inline-block text-[#00E599] font-dmsans font-extrabold text-[24px] md:text-[30px] leading-[100%] underline underline-offset-[4px] decoration-[0.5px] decoration-solid">
                Let’s Talk
              </Link>
            </div>
            
      </div>
      </div>
       <hr class="h-px my-8  border-0 dark:bg-gray-700"></hr>
    </section>
  );
};

export default CallToAction;
